import React from 'react';

const DashboardLayout = ({ children }) => {
  // Simple wrapper pour les pages dashboard protégées
  // Les pages gèrent leur propre Navbar et Sidebar
  return <>{children}</>;
};

export default DashboardLayout;
